import { Suspense, lazy } from 'react';
import { PartialRouteObject } from 'react-router';
import BaseLayout from 'src/app/shared/layouts/BaseLayout';
import SuspenseLoader from 'src/app/shared/components/SuspenseLoader';

const Loader = (Component) => (props) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Status404 = Loader(
  lazy(() => import('src/app/shared/content/pages/Status/Status404'))
);
const InitV2Page = Loader(
  lazy(() => import('src/app/feature/InitV2/pages/InitV2Page'))
);
const InitBySlugV2Page = Loader(
  lazy(() => import('src/app/feature/InitBySlugV2/pages/InitBySlugV2Page'))
);
const InitLandingV2Page = Loader(
  lazy(() => import('src/app/feature/InitLandingV2/pages/InitLandingV2Page'))
);
const MenuV2Page = Loader(
  lazy(() => import('src/app/feature/MenuV2/pages/MenuV2Page'))
);
const MenuDetailV2Page = Loader(
  lazy(() => import('src/app/feature/MenuDetailV2/pages/MenuDetailV2Page'))
);
const MenuEdit = Loader(
  lazy(() => import('src/app/feature/MenuEdit/pages/MenuEditPage'))
);
const CartV2Page = Loader(
  lazy(() => import('src/app/feature/CartV2/pages/CartV2Page'))
);
const CheckoutV2Page = Loader(
  lazy(() => import('src/app/feature/CheckoutV2/pages/CheckoutV2Page'))
);
const OnvoPaymentV2Page = Loader(
  lazy(() => import('src/app/feature/OnvoPaymentV2/pages/OnvoPaymentV2Page'))
);

const CardPaymentPage = Loader(
  lazy(() => import('src/app/feature/CardPayment/pages/CardPaymentPage'))
);
const OrderPendingReviewV2Page = Loader(
  lazy(
    () =>
      import(
        'src/app/feature/OrderPendingReviewV2/pages/OrderPendingReviewV2Page'
      )
  )
);
const ProfileEditV2Page = Loader(
  lazy(() => import('src/app/feature/ProfileEditV2/pages/ProfileEditV2Page'))
);
const ProfileV2Page = Loader(
  lazy(() => import('src/app/feature/ProfileV2/pages/ProfileV2Page'))
);
const CardsV2Page = Loader(
  lazy(() => import('src/app/feature/CardsV2/pages/CardsV2Page'))
);
const OrderV2Page = Loader(
  lazy(() => import('src/app/feature/OrderV2/pages/OrderV2Page'))
);
const OrderDetailV2Page = Loader(
  lazy(() => import('src/app/feature/OrderDetailV2/pages/OrderDetailV2Page'))
);

const routesProtected: PartialRouteObject[] = [
  {
    path: '*',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <InitLandingV2Page />
      },
      {
        path: '/menu/detail/:foodId',
        element: <MenuDetailV2Page />
      },
      {
        path: '/menu',
        element: <MenuV2Page />
      },
      {
        path: '/menu/edit/:foodId',
        element: <MenuEdit />
      },
      {
        path: '/order/detail/:orderId',
        element: <OrderDetailV2Page />
      },
      {
        path: '/cart',
        element: <CartV2Page />
      },
      {
        path: '/checkout',
        element: <CheckoutV2Page />
      },
      {
        path: '/profile',
        element: <ProfileV2Page />
      },
      {
        path: '/profile/edit',
        element: <ProfileEditV2Page />
      },
      {
        path: '/cards',
        element: <CardsV2Page />
      },
      {
        path: '/checkout/onvo-payment',
        element: <OnvoPaymentV2Page />
      },
      {
        path: '/checkout/card-payment',
        element: <CardPaymentPage />
      },
      {
        path: '/checkout/pending-review',
        element: <OrderPendingReviewV2Page />
      },
      {
        path: '/orders',
        element: <OrderV2Page />
      },
      {
        path: '/rest/:slug',
        element: <InitBySlugV2Page />
      },
      {
        path: '/:tableId',
        element: <InitV2Page />
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  }
];

export default routesProtected;
